import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry, SentryReact } from "@/sentry";

// Initialize Sentry crash reporting BEFORE rendering so any startup-time
// React errors are captured. No-ops on the web build.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryReact.ErrorBoundary fallback={<App />} showDialog={false}>
      <App />
    </SentryReact.ErrorBoundary>
  </React.StrictMode>,
);
